import { Layout } from "@/components/Layout";
import { CosaStiamoFacendo } from "@/components/CosaStiamoFacendo";
import { InfoCittadini } from "@/components/InfoCittadini";

export default function CosaFacciamoPage() {
  return (
    <Layout>
      <CosaStiamoFacendo />
      <InfoCittadini />
    </Layout>
  );
}
